export default __webpack_public_path__ + "static/media/g10-transportes-water.8d739411.svg";